import apiClient from '../apiClient';
import { GET_TOUR_GUIDE_URL } from '../apiUrl';

const getTourGuideApi = () => {
  return apiClient.get(GET_TOUR_GUIDE_URL);
};

export default getTourGuideApi;
